module.exports = __webpack_public_path__ + "static/media/sunset.3f3405e8.svg";